import { privateFetch } from "api/privateFetch";

/**
 * @typedef {{roleId: number; role: string}} RoleDetails
 * @typedef {{countryId: number; countryName: string; countryCode: string}} CountryDetails
 * @typedef {{timeZoneId: number; timeZoneName: string; tzDisplayName: string; countryId: number}} TimeZoneDetails
 * @typedef {{stateId: number; stateName: string; stateCode: string; countryId: number}} StateDetails
 * @typedef {
 * {
 * "cifNumber": number;
 * "userName": string;
 * "roleDetails": {
 *   "roleId": number;
 *   "role": string;
 * };
 * "fullName": string;
 * "emailId": string;
 * "gender": string;
 * "countryDetails": {
 *   "countryId": number;
 *   "countryName": string;
 *   "countryCode": string;
 * };
 * "timeZoneDetails": {
 *   "timeZoneId": number;
 *   "timeZoneName": string;
 *   "tzDisplayName": string;
 *   "countryId": number;
 * };
 * "stateDetails": {
 *   "stateId": number;
 *   "stateName": string;
 *   "stateCode": string;
 *   "countryId": number;
 * };
 * "phoneNumber": string;
 * "phoneCode": string;
 * "statusDetails": {
 *   "statusId": number;
 *   "statusName": string;
 * };
 * "joinedAsStudent": number;
 * "imagePath": string;
 * "cityDetails": {
 *   "cityId": number;
 *   "cityName": string;
 *   "cityCode": string;
 *   "stateId": number;
 *   "countryId": number;
 *   "stateDetails": {
 *     "stateId": number;
 *     "stateName": string;
 *     "stateCode": string;
 *     "countryId": 1
 *   };
 *   "countryDetails": {
 *     "countryId": number;
 *     "countryName": string;
 *     "countryCode": string;
 *   };
 * };
 * "addressLine1": string;
 * "addressLine2": string;
 * "zipCode": string;
 *  }} Profile
 *
 */

/**
 * Get user profile info
 * @param {string} id User ID
 * @returns {Promise<Profile>} User Profile
 */
const getProfile = async (id) => {
  const { data } = await privateFetch.get(`/users/${id}`);
  return data;
};

export default getProfile;
